import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, Select, Row, Col } from 'antd';
import { routersHelper } from '../../helpers/index';
import { isEmpty } from 'lodash';
import { v4 as uuid } from 'uuid';
import AnonymousRocket from './AnonymousRocket';
import { useDispatch, useSelector } from 'react-redux';
import { SAVE_ANONYMOUS_INFO } from '../../redux/actions/type';
import { translate } from 'react-i18next';

const ModalInformation = ({ t, showModal, setshowModal, roomName, reservationId }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const { useRouter } = routersHelper
    const router = useRouter()
    const anonymouseInfo = useSelector(state => state.contextInfo.anonymousInfo)
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
        const { name, id } = anonymouseInfo
        if (isEmpty(name) || isEmpty(id)) {
            setshowModal(true)
        }

        if (!isEmpty(name)) {
            form.setFieldsValue({
                name: decodeURIComponent(name)
            })
        }

    }, [anonymouseInfo, setshowModal, form])

    const handleOk = (e) => {
        const nameInput = form.getFieldValue(['name'])
        if (!isEmpty(nameInput)) {
            handleSubmit(nameInput)
        }
    }

    const handleName = (e) => {
        const nameInput = form.getFieldValue(['name'])
        if (!isEmpty(nameInput) && e.charCode === 13) {
            handleSubmit(nameInput)
        }
    }

    const handleCancel = (e) => {
        setshowModal(false)
        window.location.href = `${window._env_.vRoomUrl}/portal`
    }

    const handleSubmit = (nameInput) => {
        form.submit()
        setshowModal(false)
        const anonymousID = uuid()
        const { id } = anonymouseInfo
        dispatch({
            type: SAVE_ANONYMOUS_INFO,
            payload: {
                name: encodeURIComponent(nameInput),
                id: isEmpty(id) ? anonymousID : id
            }
        })
        setIsReady(true)
        // setshowAnnounce(true)
    }

    return (
        <>
            <Modal
                style={{
                    top: '70px'
                }}
                className="participant-modal-information"
                title={t('lobby_participant.modal.head')}
                visible={showModal}
                onOk={handleOk}
                closeIcon={<></>}
                footer={[
                    <Button style={{ background: '#FF0000', borderRadius: '4px' }} key="submit" type="danger" onClick={handleOk}>
                        {t('lobby_participant.modal.ok')}
                    </Button>,
                    <Button key="back" type="text" onClick={handleCancel}>
                        {t('lobby_participant.modal.cancel')}
                    </Button>,
                ]}
            >
                <Row>
                    <Col>
                        <p>
                            {t('lobby_participant.modal.info')}
                        </p>
                    </Col>
                </Row>
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        name="name"
                        label={t('lobby_participant.modal.input_label')}
                        rules={[{ required: true, message: t('lobby_participant.modal.please_specify') }]}
                    >
                        <Input placeholder={t('lobby_participant.modal.input_placeholder')} maxLength="50" onKeyPress={handleName} />
                    </Form.Item>
                    {
                        router.pathname === '/participant/live' ? (
                            <Form.Item name="room" label={t('select_label.modal.select_label')} >
                                <Select
                                    placeholder={t('select_label.modal.select_placeholder')}
                                    allowClear
                                >
                                    <Select.Option value="0">{t('lobby_participant.modal.select_option_1')}</Select.Option>
                                    <Select.Option value="1">{t('lobby_participant.modal.select_option_2')}</Select.Option>
                                </Select>
                            </Form.Item>
                        ) : null
                    }
                </Form>
            </Modal>

            <AnonymousRocket
                roomName={roomName}
                anonymouseInfo={anonymouseInfo}
                isReady={isReady}
                reservationId={reservationId}
            />
        </>
    )
}

export default translate()(ModalInformation)
